import { useMemo, useState } from "react";

import {
  Button,
  ChevronDownSVG,
  ChevronUpSVG,
  Icon,
  type SvgComponentType,
} from "@newsela/angelou";

import { getContentLibraryButtonCss } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ContentLibraryMenu/ContentLibraryMenu.styles";
import { ContentLibraryPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ContentLibraryMenu/ContentLibraryPopout";
import { NavButtonWithPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout";
import {
  getNavMenuButtonAriaProps,
  IButtonAriaProps,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout.utils";
import { NavButtonWithPopoutText } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavButtonWithPopoutText";
import useGetUserProperties from "@/users/v3/useGetUserProperties";

const MENU_ID = "nav-content-library-menu";

const ContentLibraryMenu = () => {
  const { isStudent, canViewSearch } = useGetUserProperties();

  const [isOpen, setIsOpen] = useState(false);

  const buttonAriaProps: IButtonAriaProps = useMemo(
    () =>
      getNavMenuButtonAriaProps({
        isOpen,
        id: MENU_ID,
      }),
    [isOpen],
  );

  if (!canViewSearch) return null;

  const onClickButton = () => setIsOpen((isOpen) => !isOpen);

  const buttonText = isStudent ? "Library" : "Content library";

  return (
    <NavButtonWithPopout
      id={MENU_ID}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      position={{ top: "4rem", left: 0 }}
      rootCustomCss={{ display: "flex" }}
      ButtonComponent={
        <Button
          onClick={onClickButton}
          ariaProps={buttonAriaProps}
          flavor={Button.flavors.incognito}
          __cssFor={getContentLibraryButtonCss(isOpen)}
          dataProps={{ "data-qa-selector": "global-nav-content-library-menu" }}
        >
          <NavButtonWithPopoutText>{buttonText}</NavButtonWithPopoutText>

          {isOpen ? (
            <Icon SvgComponent={ChevronUpSVG as SvgComponentType} />
          ) : (
            <Icon SvgComponent={ChevronDownSVG as SvgComponentType} />
          )}
        </Button>
      }
      PopoutComponent={<ContentLibraryPopout />}
    />
  );
};

ContentLibraryMenu.displayName = "ContentLibraryMenu";
export { ContentLibraryMenu };
